export const NoData = ({ message = "No data available" }) => (
  <div className="w-full h-full flex items-center justify-center py-10">
    <p className="text-gray-500 text-sm text-center">{message}</p>
  </div>
);